import {connect} from "react-redux"
import State from "../../models/State"
import {setSelectedSortingAction} from "../../ducks/search"
import {Sorting} from "../../models/Sorting"
import {TextModel} from "../../models/Text"

type StateProps = {
    sortOptions: Sorting
    text: TextModel
    templating: {mainTemplate: string; fallbackTemplate: string}
}

export const mapStateToProps = (state: State) => {
    return {
        sortOptions: state.search.sorting,
        text: state.text,
        templating: state.template,
    } as StateProps
}

export const mapDispatchToProps = dispatch => ({
    onSelect: (value: string) => {
        dispatch(setSelectedSortingAction(value))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
